import styled, { css } from 'styled-components'

import UnstyledBanner from '../Banner'
import backgroundImage from 'icons/background-eye.png'

export const Banner = styled(UnstyledBanner)(
  ({ theme }) => css`
    background: ${theme.colors.brand.yellow[100]} url(${backgroundImage}) right
      center / contain no-repeat;
  `
)
